<template>
    <div>
        <div
            v-if="component && component.stats && component.stats.length > 0"
            class="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4"
        >
            <template v-for="(stat, index) in component.stats" :key="stat.title">
                <inertia-link
                    v-if="stat.url !== '#'"
                    ref="statElements"
                    :href="stat.url"
                    :class="{
                        'ring-green-400': highlightedStat === index,
                        'ring-transparent': highlightedStat !== index,
                    }"
                    class="flex flex-col-reverse px-4 py-2 transition-all bg-white border rounded gap-y-2 border-neutral-200 hover:border-neutral-300 dark:border-neutral-800 dark:hover:border-neutral-600 dark:bg-black ring-2"
                >
                    <dt class="text-base leading-7 text-neutral-600 dark:text-gray-300">{{ stat.title }}</dt>
                    <dd class="text-3xl font-semibold tracking-tight dark:text-white text-neutral-900">
                        {{ stat.count }}
                    </dd>
                </inertia-link>
                <div
                    v-else
                    ref="statElements"
                    :href="stat.url"
                    :class="{
                        'ring-green-400': highlightedStat === index,
                        'ring-transparent': highlightedStat !== index,
                    }"
                    class="flex flex-col-reverse px-4 py-2 transition-all bg-transparent border rounded gap-y-2 border-neutral-200 dark:border-neutral-800 dark:bg-transparent ring-2"
                >
                    <dt class="text-base leading-7 text-neutral-600 dark:text-gray-300">{{ stat.title }}</dt>
                    <dd class="text-3xl font-semibold tracking-tight dark:text-white text-neutral-900">
                        {{ stat.count }}
                    </dd>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import { usePage } from '@inertiajs/vue3';

const { props } = usePage();

const components: Ref<any[]> = ref(props.components);
const statElements = ref<HTMLElement[]>([]);
const highlightedStat = ref<number | null>(null);

const component = [...components.value].find((component) => component.component === 'KPIBlock');

const updateStats = (newStats: any[]) => {
    newStats.forEach((newStat, index) => {
        if (component.stats[index].count !== newStat.count) {
            highlightedStat.value = index;

            setTimeout(() => {
                highlightedStat.value = null;
            }, 1000);
        }
    });

    component.stats = newStats;
};

const load = () => {
    axios.get(route('orders.admin.api.kpi')).then(({ data }) => {
        updateStats(data.stats);
    });
};

window.Echo.channel('admin').listen('.order.created', () => {
    load();
});

if (component && component.stats && component.stats.length === 0) {
    load();
}
</script>
